import { defineMessages } from 'react-intl';

const messages = defineMessages({
  widgetHeading: {
    id: 'eScMwO',
    defaultMessage:
      'Adjust the values below to see how SevOne outage avoidance can save your company',
  },
  downtimeLabel: {
    id: 'jVURxO',
    defaultMessage: 'Average unplanned downtime per year',
  },
  downtimeHelper: {
    id: '6XUxI9',
    defaultMessage: 'In hours',
  },
  costPerHourLabel: {
    id: 'jD1FRl',
    defaultMessage: 'Average cost of outage',
  },
  costPerHourHelper: {
    id: 'Wadc7m',
    defaultMessage: 'in USD',
  },
  resultHeading: {
    id: 'v5GViV',
    defaultMessage: 'Mitigate costly disruptions with SevOne',
  },
  resultDisclaimer: {
    id: 'Hu1DAF',
    defaultMessage: 'per year *',
  },
  widgetDisclaimer: {
    id: 'GFENer',
    defaultMessage:
      '* Prices shown are indicative, may vary by country, exclude any applicable taxes and duties, and are subject to product offering availability in a locale.',
  },
  benefitsHeading: {
    id: 'u0ROz8',
    defaultMessage: 'Additional benefits include but not limited to:',
  },
  benefits1: {
    id: 'RwlFpF',
    defaultMessage: '30% MTTR benefit',
  },
  benefits2: {
    id: '3Ldw55',
    defaultMessage: '25% Reduced Sales Cycle',
  },
  benefits3: {
    id: 'y4oBhN',
    defaultMessage: '25% Reduced customer churn',
  },
  benefits4: {
    id: 'f+3fwN',
    defaultMessage: '10% Customer support costs',
  },
  benefits5: {
    id: 'ywQll1',
    defaultMessage: '25% Capacity Planning',
  },
  benefits6: {
    id: 'kKiCGm',
    defaultMessage: '25% Infrastructure Automation',
  },
  primary_cta_text: {
    id: 'xSsVfT',
    defaultMessage: 'Book a live demo',
  },
  thank_you: {
    id: 'v5ZYSx',
    defaultMessage: 'Thank You!',
  },
  received_text: {
    id: 'WUASIY',
    defaultMessage:
      'We have received your request and a member of our SevOne team will contact you shortly.',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  return_est_text: {
    id: '552lEp',
    defaultMessage: 'Return to product page',
  },
});

export default messages;
